// actionTypes.js

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE'

export const ADD_USER_REQUEST = 'ADD_USER_REQUEST'
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS'
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE'

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE'

export const FETCH_PENDING_VENDORS_REQUEST = 'FETCH_PENDING_VENDORS_REQUEST'
export const FETCH_PENDING_VENDORS_SUCCESS = 'FETCH_PENDING_VENDORS_SUCCESS'
export const FETCH_PENDING_VENDORS_FAILURE = 'FETCH_PENDING_VENDORS_FAILURE'

export const APPROVE_VENDOR_REQUEST = 'APPROVE_VENDOR_REQUEST'
export const APPROVE_VENDOR_SUCCESS = 'APPROVE_VENDOR_SUCCESS'
export const APPROVE_VENDOR_FAILURE = 'APPROVE_VENDOR_FAILURE'
